<template>
  <div class="login-banner">
    <v-img
      alt="Imagem ilustrativa área de login"
      height="100%"
      position="center center"
      src="@/assets/img/login-banner.jpg"
      width="100%"
    />
    <div
      class="login-banner-logo"
      :class="[
        $vuetify.breakpoint.lgOnly ? 'login-banner-logo-lg' : '',
        $vuetify.breakpoint.xlOnly ? 'login-banner-logo-xl' : '',
      ]"
    >
      <router-link
        class="login-banner__link"
        data-cy="link_logo"
        to="/login"
        :class="[
          $vuetify.breakpoint.lgOnly ? 'login-banner__link--sm' : 'login-banner__link--lg',
        ]"
      >
        <v-img
          src="~@/assets/img/logo.svg"
          aspect-ratio="6"
          contain
        />
      </router-link>
    </div>
    <p
      class="login-banner-frase white--text text-wrap"
      data-cy="login_banner_frase"
      :class="[
        $vuetify.breakpoint.mdOnly ? 'headline' : '',
        $vuetify.breakpoint.lgAndUp ? 'display-1' : '',
      ]"
    >
      <strong>A solução definitiva de<br>pagamentos online</strong><br>
    </p>

    <p
      class="login-banner-descricao white--text text-wrap"
      data-cy="login_banner_descricao"
    >
      O <strong>Minhas Compras</strong> é o espaço da Monetizze dedicado a reunir<br>
      todas as suas compras, facilitando seus acessos e muito mais.
    </p>
  </div>
</template>

<script>
export default {
  name: 'LoginBanner',
};
</script>

<style lang="scss" scoped>
.login-banner {
  height: 100vh;
  position: relative;
  width: 41vw;

  &-logo {
    line-height: 1;
    padding: 0 0 0 7%;
    position: absolute;
    top: 45px;
    width: 100%;

    &:before {
      background: #979797;
      bottom: 0;
      content: '';
      height: 1px;
      left: 65%;
      margin: auto;
      position: absolute;
      top: 0;
      width: calc(35% + 5vw);
    }

    &-lg {
      &:before {
        left: calc(311px + 7%);
        width: calc((100% - 311px - 7%) + 107px);
      }
    }

    &-xl {
      &:before {
        left: calc(361px + 7%);
        width: calc((100% - 360px - 7%) + 107px);
      }
    }
  }

  &__link {
    display: inline-block;
    height: 7.2%;
    width: 58%;

    &--sm { max-width: 300px; }
    &--lg { max-width: 350px; }
  }

  &-frase {
    bottom: 0;
    padding: 0 3% 20% 7%;
    position: absolute;
    width: 100%;

    @media (max-height: 500px) {
      padding-bottom: 10%;
    }
  }

  &-descricao {
    bottom: 0;
    padding: 0 3% 11.3% 7%;
    position: absolute;
    width: 100%;
    max-height: 32px;
    font-size: 13.1px;

    @media (max-height: 500px) {
      padding-bottom: 8%;
    }
  }
}
</style>
